import { EmptyState, NoDataIcon, Table } from '@lmc/ui-kit'
import { Spinner } from 'components/generic'
import { NAMESPACE } from 'locale'
import { reportingConstants } from 'locale/reporting'
import { useTranslation } from 'react-i18next'
import { AuditTableDataSource } from '../utils/utils'

type AuditTableProps = {
  dataSource: AuditTableDataSource[]
  columns: any
  hasLogs: boolean
  isLoading: boolean
  count: number
  currentPage: number
  setCurrentPage: (page: number) => void
}

const AuditTable = ({
  dataSource,
  columns,
  hasLogs,
  isLoading,
  count,
  currentPage,
  setCurrentPage,
}: AuditTableProps) => {
  const { t } = useTranslation(NAMESPACE.REPORTING)

  if (isLoading) return <Spinner />

  if (!hasLogs) {
    return (
      <EmptyState
        title={t(reportingConstants.EMPTY_STATE_TITLE)}
        description={t(reportingConstants.EMPTY_STATE_DESCRIPTION)}
        icon={<NoDataIcon />}
      />
    )
  }

  return (
    <Table
      bordered
      dataSource={dataSource}
      columns={columns}
      pagination={{
        pageSize: 10,
        current: currentPage,
        onChange: (page) => {
          setCurrentPage(page)
        },
        total: count,
        showSizeChanger: false,
        position: ['bottomCenter'],
      }}
    />
  )
}

export default AuditTable
